<template>
  <div class="share-content-style">
    <ul class="editor-design">
      <li>
        アウトライン
      </li>
      <li class="flex-box">
      <!-- 背景色 -->
        <select-color
          :type="'part'"
          :target="'background'"
          :selector="null"
          :value="styles['background']"
          @updateStyles="updateStyles($event)"
        />
        <!-- 罫線 -->
        <select-border
          :type="'partsContainer'"
          :target="'border'"
          :value="styles['border']"
          @updateStyles="updateStyles($event)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectBorder from '@/components/Content/Palette/CommonLayouts/EditStyleBorder'

export default {
  props: [
    'styles',
    'sectionId',
    'partsContainerId',
  ],
  components: {
    SelectColor,
    SelectBorder,
  },
  methods: {
    updateStyles (styles) {
      this.$store.commit('updatePartsContainerStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        styles,
      })
    },
  }
}
</script>

<style lang="scss">
.share-content-style {
  .editor-design {
    .flex-box {
      margin-bottom: 0;
      padding-bottom: 10px;
      .edit-style-border {
        .common-select {
          margin-right: 0px;
        }
      }
    }
  }
}
</style>
